import React, { useState, useEffect } from 'react';
import { createTheme, makeStyles } from '@material-ui/core/styles';
import { ThemeProvider } from '@material-ui/styles';
import Avatar from '@material-ui/core/Avatar';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import FormControl from '@material-ui/core/FormControl';
import TextField from '@material-ui/core/TextField';
import { useHistory, useParams } from 'react-router-dom';
import Cookies from 'js-cookie';
import InputLabel from '@material-ui/core/InputLabel';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import InputAdornment from '@material-ui/core/InputAdornment';
import IconButton from '@material-ui/core/IconButton';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import FormHelperText from '@material-ui/core/FormHelperText';
const jwt = require('jsonwebtoken');
const axios = require('axios');

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    '& > *': {
      margin: theme.spacing(1),
    },
  },
  small: {
    width: theme.spacing(3),
    height: theme.spacing(3),
  },
  large: {
    width: theme.spacing(20),
    height: theme.spacing(20),
    fontSize: '8em',
    color: 'white',
    backgroundColor: '#26477c',
  },
}));

const theme = createTheme({
  palette: {
    primary: { main: '#26477c' },
  },
});

const AdminAddProfilePage = ({ setRefreshData, currentOrganisation }) => {
  const classes = useStyles();
  let history = useHistory();
  let [newUserName, setNewUserName] = useState('');
  let [accessLvl, setAccessLevel] = useState('user');
  let [newEmailAddress, setNewEmail] = useState('');
  let [values, setValues] = useState({
    password: '',
    confirmPassword: '',
    showPassword: false,
    showConfirmPW: false,
  });
  let [userLists, setUserLists] = useState(false);

  useEffect(() => {
    let authObj = Cookies.get('authObj');
    authObj = JSON.parse(authObj);
    let { token } = authObj;
    let apiKeys = {
      admin: 'jnjirej9reinvuiriuerhuinui',
      serviceUser: 'juit959fjji44jcion4moij0kc',
    };

    if (!userLists) {
      let config = {
        headers: {
          Authorization: `Bearer ${token}`,
          apikey: apiKeys['admin'],
        },
      };
      axios
        .get(`${process.env.REACT_APP_API}/listOfUsers`, config)
        .then((response) => {
          setUserLists(response.data.userLists);
        })
        .catch(function (error) {
          console.log(error);
        });
    }
  }, []);

  const handleChange = (prop) => (event) => {
    setValues({ ...values, [prop]: event.target.value });
  };

  const handleClickShowPassword = () => {
    setValues({ ...values, showPassword: !values.showPassword });
  };

  const handleClickShowPasswordCmPW = () => {
    setValues({ ...values, showConfirmPW: !values.showConfirmPW });
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  let authObj = Cookies.get('authObj');
  authObj = JSON.parse(authObj);
  let { token } = authObj;
  let avatarLetter = '...';

  if (newUserName) {
    avatarLetter = newUserName.split('');
    avatarLetter = avatarLetter[0];
    avatarLetter = avatarLetter.toUpperCase();
  }

  let sameEmail;
  let sameUserName;
  if (userLists) {
    sameEmail = userLists.find((user) => user.email === newEmailAddress);
    sameUserName = userLists.find((user) => user.username === newUserName);
  }

  let emailErrors = false;
  if (sameEmail || !newEmailAddress) {
    emailErrors = true;
  }

  let emailCorrectFormat = true;

  if (newEmailAddress) {
    if (!newEmailAddress.match(/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/)) {
      emailErrors = true;
      emailCorrectFormat = false;
    }
  }

  let usernameError = false;

  if (sameUserName || !newUserName) {
    usernameError = true;
  }

  let matchingPassword = false;
  let isPasswordStrong = false;
  let isConfirmedPasswordStrong = false;
  let passwordOrConfirmPasswordFilled =
    values.password || values.confirmPassword;
  if (passwordOrConfirmPasswordFilled) {
    matchingPassword = values.password === values.confirmPassword;
  }

  let password = values.password;
  let confirmedPassword = values.confirmPassword;

  if (password.match(/^(?=.*?[A-Z])(?=.*?[0-9]).{8,}$/)) {
    isPasswordStrong = true;
  }

  if (confirmedPassword.match(/^(?=.*?[A-Z])(?=.*?[0-9]).{8,}$/)) {
    isConfirmedPasswordStrong = true;
  }

  let passwordError = false;

  let confirmPasswordError = false;

  if (!values.password) {
    passwordError = true;
  }

  if (!confirmedPassword) {
    confirmPasswordError = true;
  }

  if (passwordOrConfirmPasswordFilled) {
    if (matchingPassword && isPasswordStrong) {
      passwordError = false;
    }

    if (matchingPassword && isConfirmedPasswordStrong) {
      confirmPasswordError = false;
    }
    if (!matchingPassword) {
      passwordError = true;
      confirmPasswordError = true;
    }

    if (!isPasswordStrong) {
      passwordError = true;
      confirmPasswordError = true;
    }
  }

  let passwordErrors = passwordError && confirmPasswordError;

  let errors =
    usernameError && emailErrors && matchingPassword && isPasswordStrong;
  let errorMessage;
  let alertTag = <></>;

  if (!matchingPassword && passwordOrConfirmPasswordFilled) {
    if (!values.confirmPassword) {
      if (!isPasswordStrong) {
        errorMessage = (
          <>
            <div>* Please confirm your password</div>
            <div>&nbsp;</div>
            <div>
              * Password must have at least 8 characters and contain two of the
              following: uppercase and numbers.
            </div>
          </>
        );
      } else {
        errorMessage = '* Please confirm your password';
      }
    }

    if (!values.password) {
      errorMessage = '* Please fill in your password field';
    }

    if (values.password && values.confirmPassword) {
      if (!isPasswordStrong) {
        errorMessage = (
          <>
            <div>* Confirm password and password mismatch</div>
            <div>&nbsp;</div>
            <div>
              * Password must have at least 8 characters and contain two of the
              following: uppercase and numbers.
            </div>
          </>
        );
      } else {
        errorMessage = '* Confirm password and password mismatch';
      }
    }
  }

  if (matchingPassword && (!isPasswordStrong || !isConfirmedPasswordStrong)) {
    errorMessage =
      '* Password must have at least 8 characters and contain two of the following: uppercase and numbers.';
  }

  alertTag = <span style={{ color: 'red' }}>{errorMessage}</span>;
  return (
    <>
      <ThemeProvider theme={theme}>
        <Grid container spacing={1}>
          <Grid
            style={{
              display: 'flex',
              justifyContent: 'center',
              padding: '8px',
            }}
            item
            xs={12}>
            <Avatar aria-label='recipe' className={classes.large}>
              {avatarLetter}
            </Avatar>
          </Grid>
        </Grid>
        <div>&nbsp;</div>
        <div>&nbsp;</div>
        <div>&nbsp;</div>
        <Grid container spacing={1}>
          <Grid
            style={{
              display: 'flex',
              justifyContent: 'left',
              backgroundColor: '#26477c',
              padding: '8px',
              borderRadius: '8px',
            }}
            item
            xs={12}>
            <span style={{ fontSize: '1.2em', color: 'white' }}>
              Basic Data
            </span>
          </Grid>
        </Grid>
        <div>&nbsp;</div>
        <TextField
          error={usernameError}
          helperText={
            !usernameError
              ? 'User Name is avaliable'
              : usernameError && sameUserName
              ? 'User Name is already taken'
              : !newUserName
              ? 'User Name field is required'
              : null
          }
          value={newUserName}
          style={{ width: '42%' }}
          onChange={(event) => {
            // handleLoginChange(event);
            setNewUserName(event.target.value);
          }}
          variant='outlined'
          margin='normal'
          required
          id='username'
          label='User Name'
          name='username'
          autoComplete='username'
          autoFocus
        />
        <div>&nbsp;</div>
        <FormControl className={classes.margin} variant='outlined'>
          <InputLabel htmlFor='outlined-adornment-password'>
            Password
          </InputLabel>
          <OutlinedInput
            id='outlined-adornment-password'
            error={passwordError}
            required
            type={values.showPassword ? 'text' : 'password'}
            onChange={handleChange('password')}
            endAdornment={
              <InputAdornment position='end'>
                <IconButton
                  aria-label='toggle password visibility'
                  onClick={handleClickShowPassword}
                  onMouseDown={handleMouseDownPassword}
                  edge='end'>
                  {values.showPassword ? <Visibility /> : <VisibilityOff />}
                </IconButton>
              </InputAdornment>
            }
            labelWidth={80}
          />
          <FormHelperText style={{ color: 'red' }} id='component-error-text'>
            {!values.password ? 'Password field is required' : null}
          </FormHelperText>
        </FormControl>
        &nbsp; &nbsp; &nbsp;
        <FormControl className={classes.margin} variant='outlined'>
          <InputLabel htmlFor='outlined-adornment-password'>
            Confirm Password
          </InputLabel>
          <OutlinedInput
            id='outlined-adornment-password'
            error={confirmPasswordError}
            type={values.showConfirmPW ? 'text' : 'password'}
            onChange={handleChange('confirmPassword')}
            endAdornment={
              <InputAdornment position='end'>
                <IconButton
                  aria-label='toggle password visibility'
                  onClick={handleClickShowPasswordCmPW}
                  onMouseDown={handleMouseDownPassword}
                  edge='end'>
                  {values.showConfirmPW ? <Visibility /> : <VisibilityOff />}
                </IconButton>
              </InputAdornment>
            }
            labelWidth={140}
          />
          <FormHelperText style={{ color: 'red' }} id='component-error-text'>
            {!values.confirmPassword ? 'Password field is required' : null}
          </FormHelperText>
        </FormControl>
        <div>&nbsp;</div>
        {alertTag}
        <div>&nbsp;</div>
        <Grid container spacing={1}>
          <Grid
            style={{
              display: 'flex',
              justifyContent: 'left',
              backgroundColor: '#26477c',
              padding: '8px',
              borderRadius: '8px',
            }}
            item
            xs={12}>
            <span style={{ fontSize: '1.2em', color: 'white' }}>
              Contact Details
            </span>
          </Grid>
        </Grid>
        <div>&nbsp;</div>
        <TextField
          // defaultValue={newEmailAddress ? newEmailAddress : email}
          error={emailErrors}
          value={newEmailAddress}
          style={{ width: '48%' }}
          onChange={(event) => {
            setNewEmail(event.target.value);
          }}
          helperText={
            !emailErrors
              ? 'Email Address is avaliable'
              : sameEmail
              ? 'Email address is already taken'
              : !newEmailAddress
              ? 'Email field required'
              : !emailCorrectFormat
              ? 'Incorrect email format'
              : null
          }
          variant='outlined'
          margin='normal'
          type='email'
          required
          id='email'
          label='Email Address'
          name='email'
          autoComplete='email'
          autoFocus
        />
        <div>&nbsp;</div>
        <Grid container spacing={1}>
          <Grid
            style={{
              display: 'flex',
              justifyContent: 'left',
              backgroundColor: '#26477c',
              padding: '8px',
              borderRadius: '8px',
            }}
            item
            xs={12}>
            <span style={{ fontSize: '1.2em', color: 'white' }}>
              Access Level
            </span>
          </Grid>
        </Grid>
        <div>&nbsp;</div>
        <FormControl variant='outlined' className={classes.formControl}>
          <InputLabel id='demo-simple-select-outlined-label'>
            Access Level
          </InputLabel>
          <Select
            labelId='demo-simple-select-outlined-label'
            id='demo-simple-select-outlined'
            value={accessLvl}
            onChange={(event) => {
              setAccessLevel(event.target.value);
            }}
            label='Access Level'>
            <MenuItem value={'admin'}>Full Admin Access</MenuItem>
            <MenuItem value={'serviceUser'}>Corporate Access</MenuItem>
            <MenuItem value={'user'}>Normal Access</MenuItem>
          </Select>
        </FormControl>
        <div>&nbsp;</div>
        <Grid container spacing={1}>
          <Grid
            style={{
              display: 'flex',
              justifyContent: 'left',
              padding: '8px',
            }}
            item
            xs={4}>
            <Button
              onClick={() => {
                let inputUsername = newUserName;
                let inputEmail = newEmailAddress;
                let inputAccessLvl = accessLvl;

                let checkConfirm = true;
                let body = {
                  username: inputUsername,
                  // password: newPassword,
                  email: inputEmail,
                };
                //  errors && errMsg;

                body['password'] = '';
                console.log(matchingPassword);
                if (matchingPassword) {
                  body['password'] = values.confirmPassword;
                }

                checkConfirm = !errors && !passwordErrors;

                // body['userid'] = id;
                body['organisation'] = currentOrganisation;
                body['type'] = inputAccessLvl;

                if (checkConfirm) {
                  let config = {
                    headers: {
                      Authorization: `Bearer ${token}`,
                      apikey: 'jnjirej9reinvuiriuerhuinui',
                    },
                  };
                  axios
                    .post(`${process.env.REACT_APP_API}/addUser`, body, config)
                    .then((result) => {
                      console.log(result);
                    })
                    .catch((err) => {
                      console.log(err);
                    });
                  setRefreshData(true);
                  history.push('/dashboard/admin');
                }
              }}
              variant='contained'
              color='primary'>
              Confirm
            </Button>
            <div>&nbsp;</div>
            <Button
              onClick={() => {
                history.push('/dashboard/admin');
              }}
              variant='contained'
              color='primary'>
              Back
            </Button>
          </Grid>
        </Grid>
      </ThemeProvider>
    </>
  );
};

export default AdminAddProfilePage;
